import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class TabsAccordion {
	constructor() {
		this.sections = document.querySelectorAll('[data-tabs-section]')
		if (!this.sections.length) return
		this.sections.forEach(section => this.#init(section))
	}

	#init(section) {
		const buttons = section.querySelectorAll('.tab-card')
		const images = section.querySelectorAll('[data-tab-image]')
		let activeIndex = 0
		let barTween = null
		const DURATION = 5

		const activate = index => {
			if (barTween) barTween.kill()

			buttons.forEach(b => {
				b.classList.remove('is-active')
				b.removeAttribute('data-active')
				gsap.set(b, { '--progress': '0%' })
			})
			images.forEach(img => {
				img.classList.remove('is-active')
				img.style.opacity = ''
			})

			const btn = buttons[index]
			if (!btn) return

			btn.classList.add('is-active')
			btn.offsetWidth
			btn.setAttribute('data-active', '')

			const target = section.querySelector('[data-tab-image="' + index + '"]')
			if (target) target.classList.add('is-active')

			activeIndex = index

			barTween = gsap.fromTo(
				btn,
				{ '--progress': '0%' },
				{
					'--progress': '100%',
					duration: DURATION,
					ease: 'none',
					onComplete: () => {
						activate((activeIndex + 1) % buttons.length)
					},
				}
			)
		}

		buttons.forEach(btn => {
			btn.addEventListener('click', () => {
				const index = parseInt(btn.getAttribute('data-tab-index'), 10)
				activate(index)
			})
		})

		ScrollTrigger.create({
			trigger: section,
			start: 'top bottom',
			end: 'bottom top',
			onToggle: ({ isActive }) => {
				if (isActive) barTween?.resume()
				else barTween?.pause()
			},
		})

		activate(0)
	}
}
